
angular.module('tf.directives')

    .directive('barChart',  ['C3Service','$state','Legend',function(C3Service, $state, Legend)  {
    return {
        restrict: 'E',
        template: '<div class="tf-bar"></div>',
        replace: true,
        scope:{
            data:"=",
            options :"=?",
            categories: "=?",
            groups: "=?"
        },
        link : function(scope,element,attr){

            var barSpacing = 0.5;

            var data = scope.data? C3Service.bar(scope.data.values) : [];
            var categories = _.chain(data).map(function(item){return item[0];}).value();
            var meta = scope.data && scope.data.meta? scope.data.meta : {};

            function spaceBars(){
                d3.select(element).selectAll(".c3-bar")
                    .each(function(d, i){
                        var num = categories.length;
                        var width = this.getBBox().width;
                        if(!meta[d.id]){
                            meta[d.id] = {};
                        }
                        meta[d.id].barWidth = width;

                        var padding = width * barSpacing;
                        var median = Math.floor(num/2);
                        var dist = median - i;
                        var tanslate = -dist * padding;
                        d3.select(this).attr("transform", "translate(" + tanslate + ", 0)");
                    });

                d3.select(element).selectAll(".c3-chart-text")
                    .attr('font-size', 16)
                    .each(function(d, i){
                        var num = categories.length;
                        var padding = meta[d.id].barWidth * barSpacing;
                        var median = Math.floor(num/2);
                        var dist = median - i;
                        var tanslate = -dist * padding;
                        d3.select(this).attr("transform", "translate(" + tanslate + ", 0)");
                    });
            }

            function barBehaviour(chart){
                d3.select(element).selectAll(".c3-bar")
                    .on("mouseover", function(d){
                        chart.focus(d.id);
                    })
                    .on("mouseout", function(d){
                        chart.revert();
                    })
                    .on("click", function(d){
                        var slice = meta[d.id];
                        if(slice){
                            $state.go('app.statistics.dashboard', {encoded : slice.url});
                        }
                    });
            }

            var chart = c3.generate({
                bindto: element[0],
                axis: {
                    x: {
                        show: true,
                        type: 'category',
                        categories: categories,
                        tick: {
                            format: function () { return ""; }
                        }
                    }
                },
                data: {
                    columns : data,
                    type: 'bar',
                    //groups: [scope.groups]
                    labels: true
                },
                tooltip: {
                    show: true,
                },
                legend: {
                    show: false
                },
                bar: {
                    width: {
                        ratio: 0.2
                    }

                    //width: 100
                },
                interaction: {
                    enabled: false
                },
                color: {
                    pattern: scope.options.colors
                },

                onrendered: function () {
                    Legend.create(element, this.api, scope.data, scope.options.clickKey);
                    barBehaviour(this.api);
                }
            });




            scope.$watchGroup(['data','categories','groups'], function(graphData){
                if(graphData[0]) {
                    data = C3Service.bar(graphData[0].values);
                    categories = _.chain(data).map(function(item){return item[0];}).value();
                    meta = graphData[0].meta || {};

                    chart.load({
                        unload: true,
                        columns: C3Service.bar(graphData[0].values),
                        //categories: graphData[1]
                        done : function(){
                            chart.show();
                            var categories = _.pluck(chart.data(), "id");
                            chart.hide(categories.slice(5,categories.length));
                            // setTimeout(spaceBars, 100);
                        }
                    });


                    //chart.groups([graphData[2] || []]);
                }

            });
        }
    };

}]);